import React, { useEffect, useState } from "react";
import Header from "../header";
import OrganList from "../Installments/OrganList";
import Spinner from "../Spinner/Spinner";
import InstallmentDetails from "./InstallmentProductDetail";
import { FormControl, MenuItem, Select } from "@mui/material";
import axios from "axios";
import { apiCall_domain } from "../api";
import { Box } from "@mui/material";
import InstallmentImgUpload from "./InstallmentImgUpload.js";

const Installments = (props) => {
  const [state, setState] = useState({
    display: false,
    organ: false,
    orderBy: null,
    name: null,
    loading: false,
    organId: null,
    validation: false,
    reload: false,
    spinner: false,
    month: { value: 1 },
    cost: null,
    max_month: 1,
  });

  const handleOrgan = (id) => {
    setState({ ...state, orderBy: id, organId: id });
  };
  const getData = () => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(
        `${apiCall_domain}/customer/products/installment_product_details/${state.organId}/${props.location.state.vendor_item_id}/${state.month.value}/2`,
        {
          headers: config,
        },
      )
      .then((res) => {
        setState({
          ...state,
          cost: res.data,
          max_month: res.data.max_month,
          loading: false,
        });
      });
  };

  const handleChaneMonth = (e) => {
    setState({ ...state, month: { value: e.target.value } });
  };
  useEffect(() => {
    if (state.organId != null) {
      getData();
    }
  }, [state.organId, state.month]);
  return (
    <>
      <Header showSearchBar={true} title={"فروش اقساطی"} />
      <div className="installmentCom">
        <div className="rules">
          <span className="rulesTitle">
            شرایط ، قوانین و مقررات خرید اقساطی از کاچار
          </span>
          <div className="moreRules">
            <a href={"/installments/rules"}>مشاهده بیشتر</a>
            <img src="/public/assets/icons/showMore.svg" alt="یک"></img>
          </div>
        </div>
        <div className="form">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://xyz.kacharlife.com/panel/uploads/1.pdf"
            download
          >
            فرم تعهدنامه
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://xyz.kacharlife.com/panel/uploads/2.pdf"
            download
          >
            فرم بازنشستگان و کارگر
          </a>
        </div>
        <OrganList
          realod={false}
          valid={state.validation}
          displayPopup={state.display}
          hidePopup={() => setState({ ...state, display: false })}
          organ={props.location.state.condition}
          handleOrgan={handleOrgan}
        />
        {state.loading ? (
          <div className="spinDiv">
            <Spinner />
          </div>
        ) : state.cost ? (
          <>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <FormControl>
                <Select
                  displayEmpty
                  name="models"
                  value={state.month.value}
                  inputProps={{ "aria-label": "Without label" }}
                  onChange={handleChaneMonth}
                >
                  <MenuItem disabled>تعداد اقساط ماهانه</MenuItem>
                  {[...Array(state?.max_month).keys()].map((month) => (
                    <MenuItem value={month + 1}>{month + 1}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <InstallmentDetails
              loading={state.loading}
              cost={state.cost}
              vendor_item_id={props.location.state.vendor_id}
              validation={state.validation}
            />
            <InstallmentImgUpload
              vendor_item_id={props.location.state.vendor_id}
              realod={state.reload}
              orderBy={state.orderBy}
              selectedMonth={state.month}
              loading={state.loading}
              props={props}
              organId={state.organId}
            />
          </>
        ) : null}
      </div>
    </>
  );
};

export default Installments;
